var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18.671,
    viewBox: "0 0 15 18.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-doc",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_8_10",
    "data-name": "Componente 8 \\u2013 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M10.023.137A.427.427,0,0,0,9.715,0H2.822A2.332,2.332,0,0,0,.5,2.318V15.353a2.332,2.332,0,0,0,2.322,2.318h9.356A2.332,2.332,0,0,0,14.5,15.353V5a.459.459,0,0,0-.124-.3Zm.124,1.37,2.915,3.06h-1.9a1.016,1.016,0,0,1-1.02-1.016Zm2.032,15.31H2.822a1.478,1.478,0,0,1-1.468-1.464V2.318A1.478,1.478,0,0,1,2.822.854H9.293v2.7a1.867,1.867,0,0,0,1.874,1.87h2.48v9.932A1.476,1.476,0,0,1,12.178,16.817Zm0,0",
    transform: "translate(-0.5)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M96.624,401.934H89.6a.427.427,0,0,0,0,.854h7.03a.427.427,0,1,0,0-.854Zm0,0",
    transform: "translate(-86.111 -390.063)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M96.624,401.934H89.6a.427.427,0,0,0,0,.854h7.03a.427.427,0,1,0,0-.854Zm0,0",
    transform: "translate(-86.111 -393.063)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M92.953,401.934H89.388c-.119,0-.217.192-.217.427s.1.427.217.427h3.567c.119,0,.217-.192.217-.427S93.074,401.934,92.953,401.934Zm0,0",
    transform: "translate(-86.111 -396.063)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoc);
export default __webpack_public_path__ + "static/media/ico-doc.2051848d2792cb7276b140694ab79561.svg";
export { ForwardRef as ReactComponent };